<template>
  <div class="remove-predicted-wo-actual-popup-flow">
    <remove-predicted-w-o-actual v-if="componentIndex === 0"
                                 :predicted-transaction="predictedTransaction"
                                 :close-action="close"
                                 :next-action="next" />

    <cancel-prediction-summary v-else
                               :predicted-transaction="predictedTransaction"
                               :close-action="close"
                               :back-action="back" />
  </div>
</template>

<script>
import Segment from '../../../../../../../../../../../../Segment';
import RemovePredictedWOActual from '../RemovePredictedWOActual.vue';
import CancelPredictionSummary from '../CancelPredictionSummary.vue';

export default {
  name: 'RemovePredictedWOActualFlow',
  components: {
    RemovePredictedWOActual,
    CancelPredictionSummary,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentIndex: 0,
    };
  },
  methods: {
    close() {
      Segment.trackUserInteraction('RemovePredictedWOActualFlow_Closed', {
        predictedTransaction: this.predictedTransaction,
      });
      this.$emit('close');
    },
    back() {
      this.componentIndex = 0;
    },
    next() {
      this.componentIndex = 1;
    },
  },
};
</script>
